var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.createdData
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("intra-consignment")))]),
          _c(
            "w-card-content",
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs, value: _vm.tabValue },
                on: {
                  input: function ($event) {
                    return _vm.onTabInput($event)
                  },
                },
              }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: _vm.yearInputWidth } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("common.Year"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.year,
                          callback: function ($$v) {
                            _vm.year = $$v
                          },
                          expression: "year",
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.isQuarter
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-month-select", {
                            attrs: {
                              "use-go-time": "",
                              fancy: "",
                              label: _vm.$ct("common.Month"),
                            },
                            model: {
                              value: _vm.month,
                              callback: function ($$v) {
                                _vm.month = $$v
                              },
                              expression: "month",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("app-quarter-input", {
                        model: {
                          value: _vm.quarter,
                          callback: function ($$v) {
                            _vm.quarter = $$v
                          },
                          expression: "quarter",
                        },
                      }),
                  !_vm.isDossierFilledIn
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-error-message-box", [
                            _vm._v(
                              _vm._s(
                                _vm.$ct(
                                  "dossier-is-not-complete-please-fill-in"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "confirm",
                  attrs: { disabled: _vm.sending, icon: "download" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("intra-consignment-ready-title"))),
          ]),
          _c("w-card-content", [
            _vm._v(
              " " + _vm._s(_vm.$ct("intra-consignment-ready-message")) + " "
            ),
          ]),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.close")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "confirm",
                  attrs: { icon: "download" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadPdf()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.download-pdf")))]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }